import { APITypesV1 } from "@cur8/api-client";
import { paths } from "render/routes/paths";

export function nextDestinationAfterSkinScanner({
  patientId,
  visitId,
  bloodWorkMode,
  bloodWorkAlreadyComplete,
}: {
  patientId: string;
  visitId: string;
  bloodWorkMode: APITypesV1.BloodWorkMode | undefined;
  bloodWorkAlreadyComplete: boolean;
}): string {
  if (
    bloodWorkMode === APITypesV1.BloodWorkMode.BarcodeAssignment &&
    !bloodWorkAlreadyComplete
  ) {
    return paths.assignVials.url({ patientId, visitId });
  }
  return paths.checkInSuccess.url({ patientId, visitId });
}
